import React from "react";
import { Button, Grid, Modal } from "semantic-ui-react";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { isMobile } from "utils/isMobile";
import { formatPhoneNumberToInternational } from "utils/phone";
import moment from "moment-with-locales-es6";
moment.locale("fr");

const styles = {
	column: {
		fontSize: 25,
		paddingBottom: 25,
	},
	big: {
		fontWeight: "bold",
	},
};

const ContactModal = ({ open, close, patient, openEditPatient }) => {
	return (
		<Modal open={open} onClose={close} closeOnEscape closeOnDimmerClick>
			<Modal.Header>Informations de contact</Modal.Header>
			<Modal.Content>
				<Grid>
					<Grid.Row columns={1}>
						<Grid.Column style={styles.column}>
							<span style={styles.big}>Sexe : </span>{" "}
							{patient?.gender === "m" ? <span style={{ color: "dodgerblue" }}>HOMME</span> : <span style={{ color: "deeppink" }}>FEMME</span>}
						</Grid.Column>
						<Grid.Column style={styles.column}>
							<span style={styles.big}>Nom de naissance : </span> {patient?.birth_name?.toUpperCase() || "-"}
						</Grid.Column>
						<Grid.Column style={styles.column}>
							<span style={styles.big}>Nom marital : </span> {patient?.married_name?.toUpperCase() || "-"}
						</Grid.Column>
						<Grid.Column style={styles.column}>
							<span style={styles.big}>Prénom : </span> {patient?.first_name || "-"}
						</Grid.Column>
						<Grid.Column style={styles.column}>
							<span style={styles.big}>Date de naissance : </span> {patient.birth_date ? moment(patient.birth_date).format("DD MMMM YYYY") : "/"}
						</Grid.Column>
						<Grid.Column style={styles.column}>
							<span style={styles.big}>E-mail : </span>
							{patient.email ? `${patient.email}${patient.email_comment ? ` - ${patient.email_comment}` : ""}` : "Non renseigné"}
						</Grid.Column>

						<Grid.Column style={styles.column}>
							<span style={styles.big}>Portable : </span>
							{patient.mobile_phone
								? `${formatPhoneNumberToInternational(patient.mobile_phone)}
								${patient.mobile_phone_is_relative ? "- Proche " : ""}${patient.mobile_phone_comment ? ` - ${patient.mobile_phone_comment}` : ""}`
								: "Non renseigné"}
						</Grid.Column>

						<Grid.Column style={styles.column}>
							<span style={styles.big}>Fixe : </span>
							{patient.phone
								? `${formatPhoneNumberToInternational(patient.phone)}${patient.phone_comment ? ` - ${patient.phone_comment}` : ""}`
								: "Non renseigné"}
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Modal.Content>
			<Modal.Actions>
				<SecondaryButton onClick={close} style={{ margin: isMobile() ? "-14px .25em 5px 0" : "-0 .25em 0 0" }}>
					Fermer
				</SecondaryButton>
				<Button
					color="green"
					onClick={() => {
						close();
						openEditPatient();
					}}
					style={{ margin: isMobile() ? "-14px .25em 5px 0" : "-0 .25em 0 0" }}
				>
					Modifier
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ContactModal;
